<template>
  <div>
    <div class="content-header">
      <h1>Zmena hesla</h1>
    </div>
    <section class="content">
      <div class="box">
        <div class="box-body">
          <form>
            <div class="row">
              <div class="col-md-4 col-md-offset-4">
                <text-field field-id="originalPassword"
                            label="Aktuálne heslo"
                            placeholder="Zadaj aktuálne heslo"
                            v-model="credentials.originalPassword"
                            :maxlength="20"
                            type="password"
                            validation="required|min:5|max:20"></text-field>
                <!--A little hack -> crossField validators are not able to work outside of single vue file, so vue validations are redirected to
                 upper component level (with data-vv-value-path, data-vv-name, v-validate attriibutes)-->
                <text-field field-id="newPassword"
                            label="Nové heslo"
                            placeholder="Zadaj nové heslo"
                            v-model="credentials.newPassword"
                            :maxlength="20"
                            ref="newPassword"
                            type="password"
                            data-vv-value-path="value"
                            data-vv-name="newPassword"
                            v-validate="'required|min:5|max:20'"
                ></text-field>
                <text-field field-id="confirmPassword"
                            label="Nové heslo pre kontrolu"
                            placeholder="Zadaj nové heslo znova"
                            v-model="credentials.confirmPassword"
                            :maxlength="20"
                            type="password"
                            data-vv-value-path="value"
                            data-vv-name="confirmPassword"
                            v-validate="'required|confirmed:$newPassword'"></text-field>
              </div>
            </div>
            <hr>
            <div class="text-center">
              <span>
                <router-link tag="button" to="/profile" class="btn btn-default">Zrušiť</router-link>
                <button class="btn btn-primary" type="submit" @click.prevent="save()">Uložiť</button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import _ from 'lodash';
  import validationMixin from 'components/validationMixin';
  import notificationService from 'services/notificationService';
  import textField from 'components/form/textField';

  const credentials = {
    originalPassword: '',
    newPassword: '',
    confirmPassword: '',
  };

  export default {
    components: {textField},
    mixins: [validationMixin],
    data() {
      return {
        credentials: _.clone(credentials)
      }
    },
    methods: {
      save() {
        this.$validator.validateAll().then((res) => {
          if (res) {
            this.$store.dispatch('user/myPasswordChange', this.credentials).then((result) => {
              if (result) {
                notificationService.success('Heslo bolo zmenené.');
                this.credentials = _.clone(credentials);
                this.$router.push('/profile');
              }
            })
          }
        });
      }
    }

  }
</script>



// WEBPACK FOOTER //
// client/views/passwordChange.vue